export const ACCOUNT_TYPES = {
  ENTERPRISE: 'enterprise',
  STANDARD: 'standard'
};
